import { useState } from 'react';
import { useLocale } from '../hooks/useLocale.jsx';

const CAPTION_MAX = 280;

// 게시 / 캡션 편집 공용 모달.
//   mode = 'post'  → 처음 게시. 확인 → onSubmit(caption) 호출, 부모가 setListed(true, caption).
//   mode = 'edit'  → 이미 게시된 디자인의 caption 만 수정. onSubmit(caption) → updateCaption.
export function CaptionEditor({ initial = '', mode = 'post', onSubmit, onClose }) {
  const { t } = useLocale();
  const [text, setText] = useState(initial || '');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setError('');
    try {
      await onSubmit(text.trim());
      onClose?.();
    } catch (err) {
      console.warn('caption submit failed:', err);
      setError(t('errCaptionSave'));
      setSubmitting(false);
    }
  };

  const remaining = CAPTION_MAX - text.length;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal caption-modal" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit}>
          <h3>{t('captionTitle')}</h3>
          <textarea
            className="caption-textarea"
            placeholder={t('captionPlaceholder')}
            maxLength={CAPTION_MAX}
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={4}
            autoFocus
          />
          <div className="caption-counter" aria-live="polite">{remaining}</div>
          {error && <p className="report-error">{error}</p>}
          <div className="report-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              {t('captionCancel')}
            </button>
            <button type="submit" className="btn btn-primary" disabled={submitting}>
              {mode === 'edit' ? t('captionSave') : t('captionPost')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
